import { IsNotEmpty, IsString, MaxLength, IsOptional, IsInt, IsUUID } from 'class-validator';

export class CaseEditDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(255)
    title: string;

    @IsNotEmpty()
    @IsInt()
    source: number;

    @IsNotEmpty()
    @IsString()
    errorDescription: string;

    @IsOptional()
    @IsString()
    initialAnalysis: string;

    @IsNotEmpty()
    @IsInt()
    status: number;

    @IsOptional()
    @IsUUID()
    team: string;

    @IsOptional()
    @IsUUID()
    user: string;

    @IsNotEmpty()
    @IsUUID()
    account: string;

    @IsOptional()
    @IsUUID()
    contact: string;

    @IsNotEmpty()
    @IsUUID()
    product: string;

}
